import { render, staticRenderFns } from "./estimates-templates.vue?vue&type=template&id=28e9ed5f&scoped=true"
import script from "./estimates-templates.vue?vue&type=script&lang=js"
export * from "./estimates-templates.vue?vue&type=script&lang=js"
import style0 from "./estimates-templates.vue?vue&type=style&index=0&id=28e9ed5f&prod&lang=css"
import style1 from "./estimates-templates.vue?vue&type=style&index=1&id=28e9ed5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e9ed5f",
  null
  
)

export default component.exports